import { WebApi } from '@/services/WebApi'

const state = () => ({
  loadingClientAddress: false,
  loadedClientAddress: false,
  clientAddress: null
})

const mutations = {
  setClientAddress (state, clientAddress) {
    state.clientAddress = clientAddress
    state.loadedClientAddress = true
  },
  setLoading (state, value) {
    state.loadingClientAddress = value
  }
}

const actions = {
  fetchClientAddressBySiteId ({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('Portal/' + siteId + '/Client/Address')
        .then(response => {
          commit('setClientAddress', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
